import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import AddRawMaterialLayer from "../components/AddRawMaterialLayer";

const AddRawMaterialPage = () => {
  return (
    <MasterLayout>
        <AddRawMaterialLayer />
      {/* <AddRawMaterialLayer /> */}
    </MasterLayout>
  );
};

export default AddRawMaterialPage;
